import { removeStudent as removeStudentAPI } from "../api";

export const removeStudentAction = async (classID, studentID, setClass) => {
  const classroom = await removeStudentAPI(classID, studentID);
  setClass(classroom.data)
};
